import React from 'react'
import Button from '../form/Button'

import EyeIcon from '../../../assets/icons/eye.svg?react'
import { useI18N } from '../../../libraries/i18n/hook'
import { Link } from 'react-router-dom'

type Props = { href?: string, id?: number }
const OpenDocumentButton: React.FC<Props> = ({ href, id }) => {
  const { t } = useI18N()
  return (
    <Button icon={<EyeIcon />} size='md' variant='primary' outlined>
      {(!href && id) && <Link to={`/content/documents/${id}/reader`} >{t('content.documents.seeFull')}</Link>}
      {href && <a href={href} target='_blank' rel='noreferrer'>{t('content.documents.seeFull')}</a>}
    </Button>
  )
}

export default OpenDocumentButton
